<template>
    <v-card :ripple="false" class="!p-4 !sm:p-6 !rounded-2xl !shadow-md">
        <div class="flex justify-between items-center">
            <div class="flex gap-3 items-center">
                <div class="flex justify-center items-center p-2 rounded-full bg-primary_blue bg-opacity-10">
                    <component :is="props.icon" class="h-6 w-6 fill-primary_blue" />
                </div>
                <div class="mb-1">
                    <p class="text-sm text-neutral-800">
                        {{ props.title }}
                    </p>
                    <p class="text-xs text-neutral-500 -mt-[2px]">
                        {{ props.desc }}
                    </p>
                </div>
            </div>
        </div>
    </v-card>
</template>

<script setup>
    import { Icons } from 'taxi-lib';

    const props = defineProps({
        icon: {
            required: false,
            default: Icons.TISearch,
        },
        title: {
            type: String,
            required: true,
        },
        desc: {
            type: String,
            required: true,
        },
    })
</script>